import Divider from '@components/_atoms/Divider';
import styled from '@emotion/styled';
import SummaryTextList from '../SummaryTextList';
import { useRouter } from 'next/router';
import { CAREER_JOB_RECRUIT_DETAIL } from '@constants/routes/routes';

const JobCardContainer = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1080px;
  gap: 40px;
  padding-bottom: 40px;

  cursor: pointer;

  &:hover {
    background-color: #fafafa;
  }
`;

const JobCardContentWrapper = styled.div`
  display: flex;
  width: 1080px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

const JobCardTitle = styled.p`
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.56px;
`;

const SummaryTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

const SummaryDateText = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: -0.36px;
`;

// TODO : API 나오면 swagger에서 나온 type 써야 합니다.
export type Props = {
  readonly id: number;
  readonly categoryId: number;
  readonly title: string;
  readonly summaryList: string[];
  readonly summaryDate: string;
};

export default function JobCardLi({ id, title, summaryList, summaryDate }: Props) {
  const router = useRouter();

  return (
    <>
      <JobCardContainer onClick={() => router.push(`${CAREER_JOB_RECRUIT_DETAIL}/${id}`)}>
        <Divider />
        <JobCardContentWrapper>
          <JobCardTitle>{title}</JobCardTitle>
          <SummaryTextContainer>
            <SummaryTextList summaryList={summaryList} />
            <SummaryDateText>{summaryDate}</SummaryDateText>
          </SummaryTextContainer>
        </JobCardContentWrapper>
      </JobCardContainer>
    </>
  );
}
